import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>SG Rewards Tab</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton />
    </ExpoRouterDemoScreen>
  );
}
